<ng-container *ngIf="!warehousingPopup">
  <div class="hidden"><button class="nrk-button mb-2" (click)="printPackingInforamtion()" [attr.disabled]="tree.isLoading || null">Print Packing Information</button></div>
  <div class="hidden"><button class="nrk-button" (click)="palletLabelWindow.show();this.reloadData()">Print Pallet Labels</button></div>
</ng-container>
<div *ngIf="warehousingPopup">
  <button class="btn btn-md btn-info" (click)="printPackingInforamtion()" [attr.disabled]="tree.isLoading || null">Print Packing Information</button>
  <ngx-box-label [compilation]="compilation" [warehousing]="true" [windowed]="true"></ngx-box-label>
  <button class="btn btn-md btn-info" (click)="palletLabelWindow.show();this.reloadData()">Print Pallet Labeling</button>
</div><!-- <div [ngStyle]="{ 'display' : true }"> -->

<div [ngStyle]="{ 'display' : display }">

  <div #coverSheet>
    <ng-container *ngFor="let li of compilation.lineItems; index as idx">
      <ngx-cover-sheet [print]="true" [compilation]="compilation" [lineItemIdx]="idx"></ngx-cover-sheet>
    </ng-container>
  </div>

<!--  <div #palletLabelLegacy>
    <ng-container *ngFor="let li of compilation.lineItems; index as idx">
      <ng-container *ngFor="let pallet of getPackingFor(idx); index as pidx">

        <div [attr.id]="'innerDiv-'+(compilation.lineItems.length * idx) + pidx" class="print-item-break-before" style="width:85rem">
          <!~~ <div *ngIf="packingConditions" [ngStyle]="{ 'background-color': pallet.palRef ? packingConditions.getMultiPalletColor(pallet) : null, 'position':'relative','bottom':'1rem','right':'1rem' }">
            <div style="font-size:7rem;font-weight:bold;text-align:center;">
              <span>{{packingConditions.getPos(pallet)}}/{{compilation.packingConditions.length}}</span>
            </div>
          </div> ~~>
          <table>
            <tr>
              <td>
                <div style="padding-right:1rem;width:55rem">
                  <div class="csh1" *ngIf="compilation.lineItems.length === 1">{{compilation.code}} - {{data.getBusinessName(compilation.recipient)}}</div>
                  <div class="csh1" *ngIf="compilation.lineItems.length > 1">{{compilation.code}}, Pos {{idx+1}} - {{data.getBusinessName(compilation.recipient)}}</div>
                  <!~~ <div class="csh2">Dispatch date to final customer: {{compilation.vieDispatchDate | date : 'yyyy-MM-dd'}}</div> ~~>
                  <div class="csh2">
                    <span *ngIf="isMixedPallet()" style="padding-right:3em">Mixed Pallet</span>
                    <span *ngIf="compilation.customerDocumentNumber">PO: {{compilation.customerDocumentNumber}} Pos: {{tree.getItemOrderPos(this.compilation.lineItems[idx])}}</span>
                  </div> 
                </div>
              </td>
              <td *ngIf="packingConditions">
                <div  [ngStyle]="{ 'background-color': pallet.palRef ? packingConditions.getMultiPalletColor(pallet) : null }">
                  <div style="font-size:7rem;font-weight:bold;">Pal {{packingConditions.getPos(pallet)}}/{{compilation.packingConditions.length}}</div>
                </div>
              </td>
            </tr>
          </table>

          <table class="cover-table">
            <tr>
              <td>{{li.productName}}</td>
              <!~~ <td *ngIf="li.displayUnit !== 1" style="padding-left: 1em">{{li.displayUnitQuantity}}&nbsp;{{unitData.get(li.displayUnit).short}}</td>
              <td style="padding-left: 1em">{{li.quantity}}&nbsp;pc.</td> ~~>
            </tr>
            <tr *ngIf="li.attributeRemark || li.attributeCode"><td>{{li.attributeRemark}}; {{li.attributeCode}}</td></tr>
            <tr *ngIf="li.publicRemark"><td>{{li.publicRemark}}</td><td></td><td></td></tr>
            <tr><td style="height:0.5rem;"></td></tr>
          </table>

          <ngx-packing-conditions #packingConditions [compilation]="compilation" [print]="true" [grossWeight]="grossWeight" [highlight]="pallet" [lineItemIdx]="idx"></ngx-packing-conditions>
        </div>

      </ng-container>
    </ng-container>
  </div>
-->
</div>


<div *ngIf="insidePalletLabel">
  <ng-container *ngTemplateOutlet="palletLabelTemplate;"></ng-container>
</div>


<nrk-window #palletLabelWindow>
  <nrk-header><b>Pallet Labels</b></nrk-header>
  <nrk-content>
    <ng-container *ngTemplateOutlet="palletLabelTemplate;"></ng-container>
  </nrk-content>
  <nrk-footer>
    <div class="text-center">
      <button class="nrk-button" (click)="downloadPdf('window')">Download PDF</button>
      <button class="nrk-button ml-4" (click)="palletLabelWindow.hide()">Close</button>
    </div>
  </nrk-footer>
</nrk-window>

<ng-template #palletLabelTemplate>

  <div *ngIf="compilation.palletLabelConfig && !print" class="p-4" style="background-color:#eee;margin:4px">
    <div class="mt-2">Remarks Font Size (pt) <ngx-doc-form-texfield [(value)]="compilation.palletLabelConfig.fontSize" mode="integer"></ngx-doc-form-texfield></div>
    <div class="mt-2">Remarks <ngx-form-text [multiline]="1" [(value)]="compilation.palletLabelConfig.remarks"></ngx-form-text></div>
    <button class="btn btn-info btn-sm mt-2" (click)="saveData()">Save</button>
  </div>

  <div #palletLabel>

    <ng-container *ngFor="let li of compilation.lineItems; index as idx">
      <ng-container *ngFor="let pallet of getPackingFor(idx); index as pidx">
      <!-- <ng-container *ngFor="let pallet of []; index as pidx"> -->

        <div *ngIf="pallet?.palId && palletInfo && pallet.palId && palletInfo[pallet.palId]" class="pallet-label-page">
          
          <div class="pallet-label-container">

            <div class="vcenter pallet-label-header">
              <div class="block header-text">
                <div *ngIf="compilation.lineItems.length === 1" class="header-upper">{{compilation.code}} - {{data.getBusinessName(compilation.recipient)}}</div>
                <div *ngIf="compilation.lineItems.length > 1" class="header-upper">{{compilation.code}}, Pos {{data.getPositionNumberFormat(compilation) | printf : idx+1}} - {{data.getBusinessName(compilation.recipient)}}</div>
                <div class="header-lower">
                  <span *ngIf="isMixedPallet()" style="padding-right:3em">Mixed Pallet</span>
                  <span *ngIf="compilation.customerDocumentNumber">PO: {{compilation.customerDocumentNumber}} Pos: {{tree.getItemOrderPos(this.compilation.lineItems[idx])}}</span>
                </div>
              </div>
              <div class="block nrk-logo"><img src="assets/images/nipponrika_logo.svg" /></div>
            </div>

            <div class="vcenter pallet-code">
              <div class="block qrcode"><qrcode [qrdata]="'{ doc: ' + compilation.code + ' }'" [width]="110" [errorCorrectionLevel]="'Q'" elementType="svg"></qrcode></div>
              <div class="delivery-address">{{getDeliveryAddress()}}</div>
              <div class="block pallet-el-of">
                <div  [ngStyle]="{ 'background-color': pallet.palRef ? getMultiPalletColor(pallet) : null }">
                  <div>Pallet {{getPos(pallet)}}/{{compilation.packingConditions.length}}</div>
                </div>
              </div>
            </div>

            <div class="vcenter product-decription">
              <div class="block product-text">
                {{li.productName}}<br>
                <span *ngIf="li.attributeRemark || li.attributeCode">{{li.attributeRemark}}; {{li.attributeCode}}</span><br>
                <span *ngIf="li.publicRemark">{{li.publicRemark}}</span>
              </div>
            </div>

            <div class="vcenter">
              <div class="pallet-table">
                <div class="pallet-table-header">
                  <b>
                    <span style="padding-left: 1rem">{{palletInfo[pallet.palId]?.dn}}</span>
                  </b>
                  <span style="padding-left: 2rem">{{pallet.packingType}}:</span>
                  <span style="padding-left:1rem">{{data.getOptionName(packingTypeOptions[packingForIdx[idx][pidx]], pallet.packingType)}}</span>
                </div>
                <table>
                  <thead class="thinborder-bottom">
                    <tr>
                      <th style="text-align: center">Pallet ID</th>
                      <th style="text-align: center">Pallet Type</th>
                      <th style="text-align: center">Collie Dimensions</th>
                      <th style="text-align: center">DN & Pos</th>
                      <th style="text-align: right"># Boxes</th>
                      <th style="text-align: right" *ngIf="!insidePalletLabel">Net Weight (kg)</th>
                      <th style="text-align: right" *ngIf="!insidePalletLabel">{{ compilation.packingConditions[0].weightOverride ? 'Gross Weight' : 'Calc Gross' }} (kg)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let pal of compilation.packingConditions">
                      <tr *ngIf="palletInfo[pal.palId] && (pal === undefined || pallet === pal)">
                        <td style="text-align: center">{{palletInfo[pal.palId].id}}</td>
                        <td style="text-align: center">{{pal.palletType === 'P0' ? 'no pallet' : data.getOptionName(data.palletTypeOptions, pal.palletType)}}</td>
                        <td style="text-align: center">{{palletInfo[pal.palId].dimensions}}</td>
                        <td style="text-align: center">{{palletInfo[pal.palId].dn}}</td>
                        <td style="text-align: right">{{palletInfo[pal.palId].boxes}}</td>
                        <td style="text-align: right" *ngIf="!insidePalletLabel">{{palletInfo[pal.palId].netWeight}}</td>
                        <td style="text-align: right" *ngIf="!insidePalletLabel">{{palletInfo[pal.palId].grossWeight}}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="vcenter">
              <table class="pallet-table pallet-table-sub">
                <thead class="thinborder-bottom">
                  <tr>
                    <th style="text-align: center">CS #</th>
                    <th style="text-align: center">TC #</th>
                    <th style="text-align: right"># Boxes</th>
                    <th style="text-align: right"># Pieces</th>
                    <th style="text-align: right"># Unit</th>
                    <th style="text-align: center">Type of Carton Box</th>
                    <th style="text-align: right" *ngIf="!insidePalletLabel">Net (kg)</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let row of palletInfo[pallet.palId].items">
                    <tr>
                      <td style="text-align: center">{{row.cs}}</td>
                      <td style="text-align: center">{{row.tc}}</td>
                      <td style="text-align: right">{{row.boxes}}</td>
                      <td style="text-align: right">{{row.quantity}}</td>
                      <td style="text-align: right">{{row.unitQuantity}}</td>
                      <td style="text-align: center">{{data.getOptionName(data.cartonBoxOptions, row.row.typeOfBox)}}</td>
                      <td style="text-align: right" *ngIf="!insidePalletLabel">{{row.netWeight}}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

            <div class="remarks" *ngIf="compilation.palletLabelConfig.remarks">
              <!-- <div *ngIf="!print"><ngx-form-text [multiline]="1" [(value)]="compilation.palletLabelConfig.remarks"></ngx-form-text></div> -->
              <!-- <div *ngIf="print">{{compilation.palletLabelConfig.remarks}}</div> -->
               <div style="line-height:1em" [style.font-size]="compilation.palletLabelConfig.fontSize + 'pt'">{{compilation.palletLabelConfig.remarks}}</div>
            </div>

          </div>

        </div>

      </ng-container>
    </ng-container>
  </div>
</ng-template>

